import { render, staticRenderFns } from "./SpectrumFAQs.vue?vue&type=template&id=a7750340"
import script from "./SpectrumFAQs.vue?vue&type=script&lang=js"
export * from "./SpectrumFAQs.vue?vue&type=script&lang=js"
import style0 from "./SpectrumFAQs.vue?vue&type=style&index=0&id=a7750340&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports